import React, { useCallback } from "react";
import { IconButton, IconButtonProps, useTheme } from "@material-ui/core";
import { CloseIcon } from "../../icons";
import { useNavigator } from "../AppHistory";

export const CloseButton: React.FC<IconButtonProps> = ({
  onClick,
  children,
  ...props
}) => {
  const theme = useTheme();
  const { closeOverlay } = useNavigator();

  const handleClose = useCallback(
    (e) => {
      if (typeof onClick === "function") {
        onClick(e);
      }
      closeOverlay();
    },
    [onClick, closeOverlay],
  );

  return (
    <IconButton data-testid="Button--close" onClick={handleClose} {...props}>
      {children ? children : <CloseIcon fill={theme.palette.text.primary} />}
    </IconButton>
  );
};
